import { useNavigate } from "react-router-dom";

const LogoutButton = ({ setUser}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        setUser({ 
            userName: '',
            discordID: '',
            token: '',
            isAdmin: false,
            mapPoints: []
        });

        localStorage.removeItem('user')

        navigate('/');
    }

    return (
        <button onClick={handleClick} className="logout-btn btn btn-ghost btn-header" title="Logout">
            <div className="media-container">
                <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className={"arrow"} d="M21 12L13 12" stroke="white" strokeWidth="2"/>
                    <path className={"arrow"} d="M18 15L20.913 12.087V12.087C20.961 12.039 20.961 11.961 20.913 11.913V11.913L18 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path className={"door"} d="M16 5V4.5V4.5C16 3.67157 15.3284 3 14.5 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H14.5C15.3284 21 16 20.3284 16 19.5V19.5V19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
        </button>
    );
}
 
export default LogoutButton;